export const MAX_NUMBER_PHYSICAL_CARDS = 1;
